import { render, staticRenderFns } from "./DummyPage.vue?vue&type=template&id=767c08f1&"
var script = {}
import style0 from "./DummyPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports